import {FARE_ALERT_SUBMITTED, TOGGLE_FARE_ALERT} from "../../actions/FareAlertActions";

const initialState = {
    submitted: false,
    opened: false
};

const FareAlertReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_FARE_ALERT:
            return {...state, opened: !state.opened};
        case FARE_ALERT_SUBMITTED:
            return {...state, submitted: action.payload.data};
        default:
            return state;
    }
};

export default FareAlertReducer;



// WEBPACK FOOTER //
// ./src/reducers/fareAlert/FareAlertReducer.js